import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VeiculosClvComponent } from './veiculos-clv.component';
import { CalendarModule } from 'primeng/calendar';
import {TableModule} from 'primeng/table';
import { FormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { InputMaskModule } from 'primeng/inputmask';
import { TooltipModule } from 'primeng/tooltip';
import {DynamicDialogModule} from 'primeng/dynamicdialog';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import { DialogModule } from 'primeng/dialog';

@NgModule({
  imports: [
    CommonModule,
    CalendarModule,
    TableModule,
    FormsModule,
    ToastModule,
    InputMaskModule,
    TooltipModule,
    DynamicDialogModule,
    ProgressSpinnerModule,
    DialogModule
  ],
  declarations: [VeiculosClvComponent],
  providers: [MessageService],
})
export class VeiculosClvModule {}
